import React from 'react';

import cx from 'classnames';
import { createPortal } from 'react-dom';

import s from './index.module.css';

type Props = {
  isSharedPage?: boolean;
};

function ContentIndicator({ isSharedPage }: Props) {
  const contentIndicatorRef = React.useRef<HTMLDivElement>(null);
  const [isTooltipShown, setIsTooltipShown] = React.useState(false);

  const tooltipLabel = isSharedPage ? 'Shared Content' : 'Safari Portal Content';

  return (
    <React.Fragment>
      <div
        ref={contentIndicatorRef}
        onMouseEnter={() => {
          setIsTooltipShown(true);
        }}
        onMouseLeave={() => {
          setIsTooltipShown(false);
        }}
        className={cx(s.contentIndicator, isSharedPage && s.sharedContentIndicator)}
      />

      {isTooltipShown &&
        contentIndicatorRef.current &&
        createPortal(
          <div
            style={{
              top: contentIndicatorRef.current.getBoundingClientRect().top - 4,
              left: contentIndicatorRef.current.getBoundingClientRect().left,
            }}
            className={s.tooltip}
          >
            {tooltipLabel}
          </div>,
          document.body,
        )}
    </React.Fragment>
  );
}

export { ContentIndicator };
